import React from "react";
import { useBanner } from "../../../../providers/BannerProviders";

function HomePAP() {
  const { data } = useBanner();
  const homePAP = data?.data?.find(
    (item) => item?.slug === "privacypolicy-1748585734840"
  );

  if (!homePAP) {
    return (
      <div className="container mx-auto py-20 text-center text-neutral-500">
        Loading Terms & Conditions...
      </div>
    );
  }

  return (
    <section className="bg-white">
      <div className="px-6 md:px-12 lg:px-20 py-16">
        {/* Title */}
        <h1
          className="text-3xl md:text-4xl font-bold text-md-pink-dark text-center mb-8"
          dangerouslySetInnerHTML={{ __html: homePAP?.title || "" }}
        ></h1>

        {/* Description */}
        <div
          className="prose prose-lg max-w-none prose-p:text-neutral-700 prose-strong:text-md-pink-dark"
          dangerouslySetInnerHTML={{
            __html: homePAP?.description || "",
          }}
        ></div>
      </div>
    </section>
  );
}

export default HomePAP;
